import TraysPage from "../../shared-pages/manufacturer/TraysPage";

const AreaTraysPage = ({ match }) => {
  const { id } = match.params;

  return <TraysPage manufacturerId={id} url={match.url} entityName="area" />;
};

export default AreaTraysPage;
